import React from "react";

export const WhiteLabel = () => {

    var w = window.location.host;
    //console.log("w: " + w);
    //var subdomain = w.substring(0, w.indexOf(':'));

    var company_name;
    var company_id = "";
    var company_primary_color   = "000000";
    var company_secondary_color = "999999"; // hex value
    var s3_bucket_name;
    var s3_bucket_url = "ts-white-label-website.s3-us-west-2.amazonaws.com"; // AWS url NEVER changes

    ////////////////////////////////////////////////////////
    /////////////       Main White Labels      /////////////
    //w === "localhost:3000" || w === "localhost:3001" ||
    if(w === "localhost:3000" || w === "localhost:3001" || w === "asp-trainer.trainingslate.com") {
            company_name            = "Accelerate Sports Performance";
            company_id              = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";//"6d226cf8-fedd-4e72-b892-38dac02aedbc";
            company_primary_color   = "d23720"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "asp";

    } else if (w === "ateam-trainer.trainingslate.com") {
            company_name            = "A Team Health & Fitness";
            company_id              = "e28b5e77-f23e-4d29-8bc0-3ad41a87ab82";
            company_primary_color   = "145ac1"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "ateam";

    } else if (w === "battle-trainer.trainingslate.com") {
            company_name            = "Battle Tested Fitness";
            company_id              = "ea954de1-6e6f-11ea-a519-91577bfa52fe";
            s3_bucket_name          = "battle";
    } else if (w === "creig-nakano-trainer.trainingslate.com") {
            company_name            = "Nakano Human Performance";
            company_id              = "80c28c57-ca1e-4f08-b4fb-e7663ce7f253";
            company_primary_color   = "a3de35"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "creig-nakano";

    } else if (w === "fitlab-trainer.trainingslate.com") {
            company_name            = "Fitlab";
            company_id              = "ba8039a1-75d9-11ea-9773-5105bbfa13a0";
            company_primary_color   = "232364";
            s3_bucket_name          = "fitlab";
    } else if(w === "g7-trainer.trainingslate.com") {
            company_name            = "G7";
            company_id              = "c84b2dd4-665e-4c78-be36-72d734a4f30b";
            s3_bucket_name          = "g7";
    } else if(w === "gi-trainer.trainingslate.com") {
            company_name            = "Gym Integrity";
            company_id              = "d842b7c5-cffd-49d3-992f-637b2221d3e4";
            s3_bucket_name          = "gi";
    } else if(w === "healthhub-trainer.trainingslate.com") {
            company_name            = "Health Hub";
            company_id              = "8d126130-eefd-11ea-a7f1-f54779db8de1";
            s3_bucket_name          = "healthhub";

    } else if (w === "jcee-trainer.trainingslate.com") {
            company_name            = "JCEE Fitness";
            company_id              = "78e4f760-6e72-11ea-adb0-110a6e5d34e7";
            s3_bucket_name          = "jcee";

    } else if(w === "fueledbyfour-trainer.trainingslate.com") {
            company_name            = "FueledByFour";
            company_id              = "a9ee03e2-bb4f-4d6b-b718-ee80f5d6cfd0";
            s3_bucket_name          = "fueledbyfour";
           // w === "localhost:3000"
    /*} else if(w === "localhost:3000" || w === "p4l-castro-trainer.trainingslate.com" || w === "p4l-fidi-trainer.trainingslate.com" || w === "p4l-hayes-trainer.trainingslate.com") {
            document.title          = "P4L Training"; // Set the HTML Tab Title
            company_name            = "P4L";
            company_logo            = "logo_txt.png";   // header logo
            company_login_logo      = "logo_sq.png";   // login logo
            company_primary_color   = "000000"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "p4l";

            if(w === "p4l-castro-trainer.trainingslate.com") {// || w === "localhost:3000") {
                //console.log("CASTRO LOCATION");
                company_id          = "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30";
                subdomain           = "p4l-castro-athlete"; // used in awsSNS to send texts to athlete
                athlete_url         = "p4l-castro-athlete.trainingslate.com";
            } else if (w === "p4l-fidi-trainer.trainingslate.com" || w === "localhost:3000") {
                //console.log("FIDI LOCATION");
                company_id          = "c84934b0-ebf0-11e9-911a-fbdac363f28e";
                subdomain           = "p4l-fidi-athlete"; // used in awsSNS to send texts to athlete
                athlete_url         = "p4l-fidi-athlete.trainingslate.com";
            } else if (w === "p4l-hayes-trainer.trainingslate.com" || w === "localhost:3000") {
                //console.log("HAYES LOCATION");
                company_id          = "001877c0-ebf1-11e9-a945-d5dded95ac71";
                subdomain           = "p4l-hayes-athlete"; // used in awsSNS to send texts to athlete
                athlete_url         = "p4l-hayes-athlete.trainingslate.com";
            }*/
    } else if(w === "pt-trainer.trainingslate.com") {
            company_name            = "Physical Therapt";
            company_id              = "0274fcde-a85b-4e04-bcb2-ad76e34847f1";
            company_primary_color   = "536a8c";
            s3_bucket_name          = "pt";
    } else if(w === "localhost:3000" || w === "localhost:3001" || w === "posture-trainer.trainingslate.com") {
            company_name            = "Posture Health";
            company_id              = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
            company_primary_color   = "1ab1dc";
            s3_bucket_name          = "posture";
    } else if(w === "ts-trainer.trainingslate.com") {
            company_name            = "Training Slate";
            company_id              = "97670a70-7e5a-4238-9cea-ebd24edcfc5e";
            company_primary_color   = "a3de35"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "ts";
    } else {
            ////  TS TRAINER  ////
            company_name            = "Training Slate";
            company_id              = "97670a70-7e5a-4238-9cea-ebd24edcfc5e";
            company_primary_color   = "a3de35"; // hex value (hide #, doesnt work with url str)
            s3_bucket_name          = "ts";
    }


    var company_logo        = "logo.png";      // header logo
    var company_login_logo  = "logo_sq.png";   // login logo
    var subdomain           = s3_bucket_name+"-athlete"; // used in awsSNS to send texts to athlete
    var athlete_url         = subdomain+".trainingslate.com"; // emails sent to this url

    var signup_url          = "https://"+athlete_url+"/signup";
    var reset_password_url  = "https://"+athlete_url+"/reset";
    var aws_html_assets_url = "https://"+s3_bucket_url+"/"+s3_bucket_name+"/html_assets/";

    document.title          = company_name + " Trainer"; // Set the HTML Tab Title

    ////  HTML FAVICONS  ////
    //var html_manifest      = document.getElementById('html_manifest');
    var html_apple_touch   = document.getElementById('html_apple_touch');
    var html_favicon_32    = document.getElementById('html_favicon_32');
    var html_favicon_16    = document.getElementById('html_favicon_16');
    var html_safari_pin    = document.getElementById('html_safari_pin');

    //html_manifest.href    = aws_html_assets_url + "manifest.json";
    html_apple_touch.href = aws_html_assets_url + "apple-touch-icon.png";
    html_favicon_32.href  = aws_html_assets_url + "favicon-32x32.png";
    html_favicon_16.href  = aws_html_assets_url + "favicon-16x16.png";
    html_safari_pin.href  = aws_html_assets_url + "safari-pinned-tab.svg";

    var existing_trainer_id = localStorage.getItem('trainer_company_id');

    ////  Used if a trainer logs in and is on a free trial
    ////  All (free trial) trainers are under the TS parent company umbrella,
    ////  so don't override an existing company_id
    var trial_trainer = false;

    // *Note: Testing independent trainers on ts-trainer.ts.com: when switching from trainer to trainer
    //        during debug/test mode, ensure the user refreshes the login page to “reset” the session vars
    if(company_id === '97670a70-7e5a-4238-9cea-ebd24edcfc5e' && existing_trainer_id != null && existing_trainer_id != "null") {
        trial_trainer = true;
        // Change company_id since trainer is his own freelance company; however,
        // if user is not a freelancer but on the TS site, use the original company id
        // This logic is ONLY used when visiting the TS-trainer.ts.com site
        company_id = existing_trainer_id;
    }
    // End Free trial Trainer code

    ////  Check if vars below are undefined; if so, don't assign new value  ////
    if(company_id != undefined && trial_trainer == false)  sessionStorage.setItem('company_id', company_id);
    if(company_name != undefined)            sessionStorage.setItem('company_name', company_name);
    if(company_logo != undefined)            sessionStorage.setItem('company_logo', company_logo);
    if(company_login_logo != undefined)      sessionStorage.setItem('company_login_logo', company_login_logo);
    if(company_primary_color != undefined)   sessionStorage.setItem('company_primary_color', company_primary_color);
    if(company_secondary_color != undefined) sessionStorage.setItem('company_secondary_color', company_secondary_color);
    if(s3_bucket_name != undefined)          sessionStorage.setItem('s3_bucket_name', s3_bucket_name);
    if(s3_bucket_url != undefined)           sessionStorage.setItem('s3_bucket_url', s3_bucket_url);
    if(subdomain != undefined)               sessionStorage.setItem('subdomain', subdomain);

    if(athlete_url != undefined) {           sessionStorage.setItem('new_sign_up_url', signup_url);
                                             sessionStorage.setItem('athlete_url', athlete_url);
                                             sessionStorage.setItem('reset_password_url', reset_password_url);
    }

    //if(w === "p4l-castro-trainer.trainingslate.com" || w === "p4l-fidi-trainer.trainingslate.com" || w === "p4l-hayes-trainer.trainingslate.com") {
        /*var location = "hayes";
        if(w === "p4l-castro-trainer.trainingslate.com")
            location = "castro";
        else if(w === "p4l-fidi-trainer.trainingslate.com")
            location = "fidi";


        var trainer_url                 = "p4l-"+location+"-trainer.trainingslate.com";
        var trainer_signup_url          = "https://"+trainer_url+"/signup";
        var reset_trainer_password_url  = "https://"+trainer_url+"/reset";
        sessionStorage.setItem('new_trainer_sign_up_url', trainer_signup_url);
        sessionStorage.setItem('reset_trainer_password_url', reset_trainer_password_url);*/
    //}
}

//////////////////////////////////////
////  GET PARAMETERS FROM IFRAME  ////
let getParamValue = function(paramName){
    var url = window.location.search.substring(1); //get rid of "?" in querystring
    var qArray = url.split('&'); //get key-value pairs
    for (var i = 0; i < qArray.length; i++){
        var pArr = qArray[i].split('='); //split key and value
        if (pArr[0] === paramName) {
            return pArr[1]; //return value
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/WhiteLabelProps.js